export const uk = {
    addMoney: 'Пополнить счет',
    archived: 'В архіві',
    'campaign-type-content_promotion': 'Продвижение контента',
    'campaign-type-cpm_banner': 'Медийная кампания',
    'campaign-type-cpm_deals': 'Частные сделки',
    'campaign-type-cpm_price': 'Прайсовая кампания',
    'campaign-type-cpm_yndx_frontpage': 'Медийная кампания на Главной',
    'campaign-type-dynamic': 'Динамические объявления',
    'campaign-type-internal_autobudget': 'Автобюджетная кампания',
    'campaign-type-internal_distrib': 'Дистрибуционная кампания',
    'campaign-type-internal_free': 'Бесплатная кампания',
    'campaign-type-mcbanner': 'Баннер на поиске',
    'campaign-type-mobile_content': 'Реклама мобильных приложений',
    'campaign-type-performance': 'Смарт-баннеры',
    'campaign-type-text': 'Текстово-графические объявления',
    changeCampaignDayBudget: 'Изменить дневное ограничение РК',
    changeWalletDayBudget: 'Изменить ограничение общего счета',
    'description-content_promotion':
        'Позволяет продвигать контент на выбранной площадке с возможностью привлечения целевой аудитории по выбранным вами запросам.',
    'description-cpm_banner':
        'Имиджевая реклама с оплатой за показы. Создает нужные ассоциации с брендом с помощью интерактивных и привлекательных форматов: баннеров, видео, цифровой наружной рекламы.',
    'description-cpm_deals':
        'Охватная имиджевая реклама на определённых сайтах. Вы сможете выбрать не только аудиторию, но и конкретные площадки показа.',
    'description-cpm_yndx_frontpage':
        'Для охвата максимальной аудитории и создания интереса к бренду. Премиальный баннер на Главной странице Яндекса, которую ежедневно посещают миллионы пользователей. Оплата за тысячу показов.',
    'description-dynamic':
        'Автоматическое создание текстовых объявлений — точечно под каждый ваш товар и соответствующий ему запрос.',
    'description-internal_autobudget': 'Автобюджетная кампания - описание',
    'description-internal_distrib': 'Дистрибуционная кампания - описание',
    'description-internal_free': 'Бесплатная кампания - описание',
    'description-mcbanner':
        'Заметный брендированный баннер справа от результатов поиска. Привлекает целевую аудиторию по выбранным вами запросам.',
    'description-mobile_content':
        'Формат объявлений, с помощью которого можно продвигать ваши приложения для iOS и Android. Позволяет получить максимум установок по оптимальной цене.',
    'description-performance':
        'Динамические товарные баннеры. Система автоматически подбирает рекламное предложение под каждого конкретного пользователя.',
    'description-text':
        'Универсальные объявления — подходят для рекламы большинства товаров и услуг. Настройки позволяют подстроить кампанию под целевую аудиторию.',
    draft: 'Чернетка',
    'hint-content_promotion': 'Показы на Яндекс.Видео',
    'hint-cpm_banner': 'Показы в РСЯ с оплатой за показ',
    'hint-cpm_deals': 'Показы на выбранных ресурсах',
    'hint-cpm_yndx_frontpage': 'Показы на главной странице Яндекса',
    'hint-dynamic': 'Показы на поиске',
    'hint-internal_autobudget': 'Автобюджетная кампания - подсказка',
    'hint-internal_distrib': 'Дистрибуционная кампания - подсказка',
    'hint-internal_free': 'Бесплатная кампания - подсказка',
    'hint-mcbanner': 'Показы на поиске',
    'hint-mobile_content': 'Только на мобильных устройствах',
    'hint-performance': 'Показы в сетях',
    'hint-text': 'Показы на поиске и в сетях',
    isInProgress: 'В обработке',
    isNotRecovered: 'Не подлежит восстановлению',
    isOverOnDate: 'Закончилась {date}',
    moderationDenied: 'Отклонена на модерации',
    moderationPending: 'На модерации',
    moneyFinished: 'Недостаточно средств',
    noActiveBanners: 'Нет активных баннеров',
    sendToModeration: 'Отправить на модерацию',
    showsWillStartAtTime: 'Показы начнутся в {time}',
    showsWillStartOnDateAtTime: 'Показы начнутся {date}  в {time}',
    showsWillStartOnFridayAtTime: 'Показы начнутся в пятницу в {time}',
    showsWillStartOnMondayAtTime: 'Показы начнутся в понедельник в {time}',
    showsWillStartOnSaturdayAtTime: 'Показы начнутся в субботу в {time}',
    showsWillStartOnSundayAtTime: 'Показы начнутся в воскресенье в {time}',
    showsWillStartOnThursdayAtTime: 'Показы начнутся в четверг в {time}',
    showsWillStartOnTuesdayAtTime: 'Показы начнутся во вторник в {time}',
    showsWillStartOnWednesdayAtTime: 'Показы начнутся в среду в {time}',
    showsWillStartTomorrowAtTime: 'Показы начнутся завтра в {time}',
    started: 'Запущена',
    stopped: 'Остановлена',
    temporarilyPaused: 'Временно остановлена',
    waitPayment: 'Ожидает оплаты',
    willStartOnDate: 'Начнется {date}'
};
